import React, { useEffect, useRef, useState } from 'react';
import { Routes, Route, useNavigate, Navigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { getRole, getToken, getUserId } from '../Redux/selecters/index';
import { handleCurrency } from '../Redux/actions/currency';
import { createHubConnection, invokeLogin } from '../POS/services/signalRService';
import ApiService from '../POS/services/apiService';
import { saveLogin, setUserRole } from '../Redux/actions';
import userManagement from '../POS/services/userManagement';
import { SET_USER_ID } from '../Redux/actions/types';

// Layouts
import PlainLayout from '../POS/component/pages/SideBar/plainLayout';
import CashierLayout from '../POS/Cashier/components/cashierLayout';
import MainLayout from '../POS/component/pages/SideBar/mainLayout';
import MainInventoryLayout from '../INVENTORY/Layouts/mainLayout';

// Auth
import InventoryLogin from '../INVENTORY/Components/login/login';
import Signup from '../POS/component/pages/user/signup';
import KDSLogin from '../POS/component/pages/user/kdsLogin';

// Customer
import CustomerMenu from '../POS/Customer/Menu/customerMenu';
import AddtoCart from '../POS/Customer/Cart/cart';
import CardDetails from '../POS/Customer/Payment/cardDetails';
import WaitPage from '../POS/Customer/Payment/waitPage';
import ThirdParty from '../POS/Customer/thirdParty/thirdParty';
import CustomerCombo from '../POS/Customer/Combo/combo';

// Kitchen
import KitchenDisplay from '../POS/KDS/kitchenDisplay';
import KitchenHistory from '../POS/KDS/kitchenHistory';
import KitchenOrderDetail from '../POS/KDS/detail';

// Cashier
import CashierMenu from '../POS/Cashier/pages/cashierMenu';
import CounterSelector from '../POS/Cashier/components/counter/counterSelector';
import SwitchUserScreen from '../POS/Cashier/pages/openCash/swtichUserScreen';
import PaymentComponent from '../POS/Cashier/components/flocashPayment';
import OpeningCash from '../POS/Cashier/pages/openCash/openingCash';
import OpenCashList from '../POS/Cashier/pages/openCash/openCashList';
import DayCloseForm from '../POS/Cashier/components/DayClose/dayCloseForm';
import HandOvered from '../POS/Cashier/components/handOverForm/handOverList';
import Dispute from '../POS/Cashier/pages/dispute';
import HandOverForm from '../POS/Cashier/components/handOverForm/handOverform';
import PayIn from '../POS/Cashier/pages/payIn';
import PayOut from '../POS/Cashier/pages/payOut';
import PayInForm from '../POS/Cashier/components/PayIn_out_Form/payInForm';
import PayOutForm from '../POS/Cashier/components/PayIn_out_Form/payOutForm';
import DayOpeningForm from '../POS/Cashier/components/DayOpening/dayOpeningForm';
import DayOpeningList from '../POS/Cashier/components/DayOpening/DayOpeningList';
import WaiterCall from '../POS/Cashier/components/waiterCall/waiterCall';
import SaleHistory from '../POS/Cashier/components/saleHistory/saleHistory';
import PayLater from '../POS/Cashier/components/saleHistory/payLater';
import UpdateOrder from '../POS/Cashier/components/updateOrder/updateOrder';
import CashOrderDetail from '../POS/Cashier/components/saleHistory/cashOrderDetail';
import CardPayment from '../POS/Cashier/components/cashierPayment/cardPayment';
import Table from '../POS/Cashier/components/Table/table';
import NewReservation from '../POS/Cashier/components/Table/newReservation';
import Delivery from '../POS/Cashier/components/Delivery/Delivery';
import DeliveryList from '../POS/Cashier/components/Delivery/DeliveryList';

// Admin
import Dashboard from '../POS/component/pages/Dashboard/dashboard';
import Orders from '../POS/component/pages/orders/order';
import OrderDragNDrop from '../POS/component/pages/orders/orderD&D';
import SingleOrder from '../POS/component/pages/orders/singleOrder/singleOrder';
import Menu from '../POS/component/pages/menus/menu';
import ItemDetails from '../POS/component/pages/menus/itemDetails/itemDetail';
import ItemNavBar from '../POS/component/pages/menus/addItems/ItemNavBar';

// Customer Mgmt
import Costumer from '../POS/component/pages/AdminCustomer/customer';
import AddCostumer from '../POS/component/pages/AdminCustomer/AddCustomer';
import CostumerDetails from '../POS/component/pages/AdminCustomer/customerDetail';

// Employees
import Employee from '../POS/component/pages/Employees/employee';
import AddEmployee from '../POS/component/pages/Employees/createEmployee';
import EmployeeDetails from '../POS/component/pages/Employees/employeeDetails';

// Restaurant
import Restaurant from '../POS/component/pages/Restaurants/restaurant';
import CreateRestaurant from '../POS/component/pages/Restaurants/createRestaurant';
import CreateBranch from '../POS/component/pages/Restaurants/createBranch';

// Master
import AddCategory from '../POS/component/pages/master/addCategory';
import AddSubCategory from '../POS/component/pages/master/createSubCategory';
import AddVarients from '../POS/component/pages/master/variants';
import CreateModifier from '../POS/component/pages/menus/addItems/createModifiers';
import CreateAddOn from '../POS/component/pages/menus/addItems/createAddOn';
import AddCombos from '../POS/component/pages/menus/addItems/createCombo';
import UploadFile from '../POS/component/pages/master/uploadFile';
import AddCurrency from '../POS/component/pages/master/currencyManagment/currencyManagment';
import CurrencyDetail from '../POS/component/pages/master/currencyManagment/currencyDetail';
import TaxManagment from '../POS/component/pages/master/taxManagment';
import AdminMaster from '../POS/component/pages/menus/addItems/createMenuItem';
import UpdateMenuItem from '../POS/component/pages/menus/addItems/updateMenuItem';
import TableMaster from '../POS/component/pages/master/tableMaster/tableMaster';
import KitchenMaster from '../POS/component/pages/master/kitchenMaster/kitchenMaster';
import CreateMethod from '../POS/component/pages/master/paymentMethodMaster/createMethod';
import CreateDiscount from '../POS/component/pages/master/discountMaster/discountMaster';
import PromotionMaster from '../POS/component/pages/master/promotionMaster/promotionMaster';
import UserClaim from '../POS/component/pages/master/userRolesMaster/userClaim';
import UserRole from '../POS/component/pages/master/userRolesMaster/userRole';
import UserMaster from '../POS/component/pages/master/userMaster/userMaster';
import ManageUsers from '../POS/component/pages/master/userMaster/manageUser';
import EditUserRole from '../POS/component/pages/master/userMaster/editUserRole';
import EditRoleRights from '../POS/component/pages/master/userMaster/editRoleRights';
import ManageRoles from '../POS/component/pages/master/userMaster/manageRole';
import AddItemsMaster from '../POS/component/pages/master/ItemMaster/itemMaster';
import BrandMaster from '../POS/component/pages/master/brandMaster/brandMaster';
import MasterPage from '../POS/component/pages/master/masterPage/masterPage';
import AreaMaster from '../POS/component/pages/master/areaMaster/areaMaster';
import CreateCounter from '../POS/component/pages/master/counterMaster/counterMaster';
import DeliveryPlatforms from '../POS/component/pages/master/deliveryPlatforms/createDPlatforms';
import MarchaintMaster from '../POS/component/pages/master/MarchantMaster/merchantMaster';
import TerminalMaster from '../POS/component/pages/master/terminalMaster/terminalMaster';

// Settings
import Notification from '../POS/component/pages/setting/Notification';
import PasswordReset from '../POS/component/pages/setting/user';
import CurrencySetting from '../POS/component/pages/setting/currency';
import TaxSetting from '../POS/component/pages/setting/taxsetting';
import ThemeSetting from '../POS/component/pages/setting/themeSetting';

// Payment
import PaymentManagment from '../POS/component/pages/payment/paymentManagment';

// Reports
import ReportsPage from '../POS/component/pages/master/masterPage/reportsPage';
import ReportsDashboard from '../POS/component/pages/reports/dashboard/reportsDashboard';
import ReportGrid from '../POS/component/pages/reports/Grid/reportGrid';
import TotalOrder from '../POS/component/pages/reports/totalOrder';
import SaleSummeryReport from '../POS/component/pages/reports/saleReport/saleSummeryReport';
import ThirdPartReport from '../POS/component/pages/reports/thirdPartReport/thirdPartReport';
import ThirdPartyGrid from '../POS/component/pages/reports/thirdPartReport/thirdPartyGrid';
import DeliveryReport from '../POS/component/pages/reports/Delivery/DeliveryReport';
import TaxReport from '../POS/component/pages/reports/taxReport/taxReport';
import CashReport from '../POS/component/pages/reports/CashInOut/cashInOut';
import TableReport from '../POS/component/pages/reports/table/tableReport';
import XReceipt from '../POS/component/pages/reports/xReport/xReport';
import ZReport from '../POS/component/pages/reports/xReport/zReport';
import CategorySaleReport from '../POS/component/pages/reports/categorySale/categorySaleReport';
import CashierSaleReport from '../POS/component/pages/reports/saleReport/cashierSaleReport';
import PaymentSaleReport from '../POS/component/pages/reports/saleReport/paymentSaleReport';
import CustomerReport from '../POS/component/pages/reports/customerReport/customerReport';
import ItemSaleReport from '../POS/component/pages/reports/itemSale/itemSaleReport';
import SaleTaxReport from '../POS/component/pages/reports/saleReport/taxReport';
import ShiftOpen from '../POS/component/pages/reports/shiftReports/shiftReports';
import DayReports from '../POS/component/pages/reports/shiftReports/dayReports';

// Other
import PostingPOS from '../POS/component/posting/posting';
import LandingPage from '../POS/LandingPage/landingPage';
import NotFoundPage from '../POS/LandingPage/notFound/notFound';
import ItemBulkUpload from '../POS/component/pages/master/BulkUpload/itemBulkUpload';
import SalesSummaryReport from '../POS/component/pages/reports/saleReport/salesTotal';
import SalesByHourReport from '../POS/component/pages/reports/saleReport/salesHourReport';
import ProfitMarginReport from '../POS/component/pages/reports/saleReport/profitMargin';
import BestWorstSalesReport from '../POS/component/pages/reports/saleReport/best&worstSale';
import SalesTaxReport from '../POS/component/pages/reports/saleReport/salesTaxSummary';
import DailySalesSummaryReport from '../POS/component/pages/reports/saleReport/dailySaleReport';
import PurchaseTaxReport from '../POS/component/pages/reports/saleReport/purchaseSaleSummary';
import FlashSaleReport from '../POS/component/pages/reports/saleReport/flashSaleReport';

const Loader = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: 18,
      background: '#f5f5f5',
      color: '#666',
    }}
  >
    <div style={{ textAlign: 'center' }}>
      <div style={{ fontSize: 24, marginBottom: 10 }}>🔄</div>
      Loading…
    </div>
  </div>
);

function ProtectedRoute({ allowedRoles, children }) {
  const role = useSelector(getRole);
  const token = useSelector(getToken);
  const location = useLocation();

  if (!token) {
    localStorage.clear();
    window.location.href = 'https://app.pro360erp.com/';
    return null;
  }

  if (!role) {
    return <Loader />;
  }

  if (!allowedRoles.includes(role)) {
    console.log(`Role ${role} not in allowed roles:`, allowedRoles);

    // redirect somewhere safe
    return (
      <Navigate to={role === 'Cashier' || role === 'Waiter' ? '/cashier/home' : role === 'Admin' ? '/home' : '/login'} state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
}

/* ---- helpers for branchId (from GET_EMPLOYEE) ---- */
const extractBranchId = (emp) =>
  emp?.res_Branch_Id ?? emp?.BranchId ?? emp?.branchId ?? emp?.BranchID ?? emp?.branchID ?? emp?.branchNo ?? emp?.branch?.id ?? null;

const ensureBranchInLocal = (employeeLike) => {
  console.log('GET_EMPLOYEE employeeLike:', employeeLike);
  const bid = extractBranchId(employeeLike);
  console.log('Extracted BranchId =', bid);
  if (bid != null) localStorage.setItem('BranchId', String(bid));
  return bid != null;
};

const AppRoutes = () => {
  const role = useSelector(getRole);
  const token = useSelector(getToken);
  const userid = useSelector(getUserId);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [isInitializing, setIsInitializing] = useState(true);
  const [isEnsuringBranch, setIsEnsuringBranch] = useState(false);
  const initRef = useRef(false);
  const apiService = new ApiService();

  /* ---------- MAIN INITIALIZATION ---------- */
  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    const initialize = async () => {
      try {
        const urlParams = checkUrlParameters();
        if (urlParams) {
          await handleUrlLogin(urlParams);
          return;
        }

        const existingToken = localStorage.getItem('Token');
        if (!existingToken) {
          localStorage.clear();
          window.location.href = 'https://app.pro360erp.com/';
          return;
        }

        const userRole = userManagement.getUserRole(existingToken);
        console.log('Extracted role:', userRole);

        if (userRole) {
          dispatch(setUserRole(userRole));

          // ✅ userId is derived from token, not companies array
          const userIdFromToken = await userManagement.getUserId(existingToken);
          if (userIdFromToken) {
            dispatch({ type: SET_USER_ID, payload: userIdFromToken });
            invokeLogin(userIdFromToken);
          }

          const currentPath = location.pathname;
          if (currentPath === '/' || currentPath === '/login') {
            await navigateToRoleHome(userRole, userIdFromToken);
          }
        } else {
          console.error('Could not extract role from token');
          localStorage.clear();
          window.location.href = 'https://app.pro360erp.com/';
        }
      } catch (error) {
        console.error('Initialization error:', error);
        localStorage.clear();
        window.location.href = 'https://app.pro360erp.com/';
      } finally {
        setIsInitializing(false);
      }
    };

    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* ---------- URL PARAM HELPERS ---------- */
  const checkUrlParameters = () => {
    const url = window.location.href;
    const regex = /_username=([^&]+)&_password=([^&]+)&_db=([^&]+)&_baseDb=([^&]+)/;
    const match = url.match(regex);
    if (match) {
      const [, username, password, db, baseDb] = match;
      if (username && password && db && baseDb) {
        return { username, password, db, baseDb };
      }
    }
    return null;
  };

  const handleUrlLogin = async (params) => {
    try {
      const body = {
        email: params.username,
        password: params.password,
        basedb: params.baseDb,
        supportdb: params.db,
      };
      debugger;
      const response = await apiService.post('GET_ENCRYPT_TOKEN', body);

      if (response?.status === 200 && response?.data?.data?.accessToken) {
        const userData = response.data.data;

        // ====== STORE TOKENS ======
        localStorage.setItem('Token', userData.accessToken);
        localStorage.setItem('RefreshToken', userData.refreshToken);

        // ====== STORE COMPANIES ======
        const companies = userData.userCompanies || [];
        localStorage.setItem('userCompanies', JSON.stringify(companies));

        // ====== STORE ACTIVE DB ======
        if (userData.dataDb) {
          localStorage.setItem('activeDB', userData.dataDb);
        }

        const activeCompany = companies.find((c) => (c.dataDB || c.dataDb) === userData.dataDb);
        if (activeCompany?.companyNo) {
          localStorage.setItem('selectedCompanyNo', String(activeCompany.companyNo));
        }

        // ====== DISPATCH REDUX STATES ======
        dispatch(saveLogin(response.data));

        // ✅ Use token to derive userId
        const userIdFromToken = await userManagement.getUserId(userData.accessToken);
        if (userIdFromToken) {
          dispatch({ type: SET_USER_ID, payload: userIdFromToken });
        }

        const userRole = userManagement.getUserRole(userData.accessToken);
        dispatch(setUserRole(userRole));

        if (userIdFromToken) invokeLogin(userIdFromToken);

        cleanUrlParameters();

        toast.success('Login successful!');
        await navigateToRoleHome(userRole, userIdFromToken);
      } else {
        throw new Error('Invalid login response');
      }
    } catch (error) {
      console.error('URL login failed:', error);
      toast.error(error?.response?.data?.message || 'Login failed');
      localStorage.clear();
      window.location.href = 'https://app.pro360erp.com/';
    } finally {
      setIsInitializing(false);
    }
  };

  /* ---------- ROLE-BASED NAV (ensures BranchId when needed) ---------- */
  const navigateToRoleHome = async (userRole, currentUserId) => {
    switch (userRole) {
      case 'Admin':
        // If Admin also needs BranchId at start, you could do:
        // await ensureBranchIdForCashierFlow(currentUserId);
        navigate('/home', { replace: true });
        break;

      case 'Cashier':
      case 'Waiter': {
        // First time only: ensure BranchId exists
        await ensureBranchIdForCashierFlow(currentUserId);

        const counterData = localStorage.getItem('Counter');
        let hasValidCounter = false;

        if (counterData) {
          try {
            const counter = JSON.parse(counterData);
            hasValidCounter = !!(counter?.counterId && (counter?.shiftId || counter?.dayId));
          } catch {
            localStorage.removeItem('Counter');
          }
        }

        navigate(hasValidCounter ? '/cashier/home' : '/cashier/counterselection', {
          replace: true,
        });
        break;
      }

      case 'Inventory Manager':
        navigate('/inventory/dashboard', { replace: true });
        break;

      case 'Customer':
        navigate('/customer/menu', { replace: true });
        break;

      default:
        console.warn('Unknown role:', userRole);
        localStorage.clear();
        window.location.href = 'https://app.pro360erp.com/';
    }
  };

  // Call GET_EMPLOYEE, store BranchId, but only if not already set
  const ensureBranchIdForCashierFlow = async (currentUserId) => {
    if (localStorage.getItem('BranchId')) return;
    if (!currentUserId) {
      console.warn('No userId provided to ensureBranchIdForCashierFlow');
      return;
    }

    setIsEnsuringBranch(true);
    try {
      const param1 = `?UserId=${currentUserId}`;
      const res = await apiService.getApiParamater('GET_EMPLOYEE', param1);

      // ✅ assume API returns an array; we take the first employee object
      const emp = res?.data?.result?.[0];

      const ok = ensureBranchInLocal(emp);
      if (!ok) {
        console.warn('branchId not found in GET_EMPLOYEE response', emp);
      }
    } catch (err) {
      console.error('GET_EMPLOYEE failed:', err);
    } finally {
      setIsEnsuringBranch(false);
    }
  };

  /* ---------- UTIL ---------- */
  const cleanUrlParameters = () => {
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('_username');
      url.searchParams.delete('_password');
      url.searchParams.delete('_db');
      url.searchParams.delete('_baseDb');
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      console.error('Error cleaning URL:', error);
    }
  };

  /* ---------- FETCH CURRENCY WHEN AUTHED ---------- */
  useEffect(() => {
    if (role && token) fetchCurrency();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role, token]);

  const fetchCurrency = async () => {
    try {
      const param = '?UserToken=' + token;
      const res = await apiService.getApiParamater('GET_CURRENCY', param);
      const currency = res?.data?.result?.find((c) => c?.default === true);
      if (currency) dispatch(handleCurrency(currency));
    } catch (error) {
      console.error('Currency fetch error:', error);
    }
  };

  /* ---------- SIGNALR ---------- */
  useEffect(() => {
    if (!role || !token) return;

    const handleReceiveMessage = (_user, message) => {
      if (role === 'Admin' || role === 'Cashier' || role === 'Waiter') toast.success(message);
    };

    const handleReceiveAck = () => console.log('Received acknowledgment');

    const handleReceiveRejection = (user, message) => {
      if (role === 'Admin' || role === 'Cashier' || role === 'Waiter') {
        toast.error(`Rejection from ${user}: ${message}`);
      }
    };

    const hubConnection = createHubConnection(handleReceiveMessage, handleReceiveAck, handleReceiveRejection);
    return () => {
      if (hubConnection) hubConnection.stop();
    };
  }, [role, token]);

  /* ---------- AUTH CHECK ---------- */
  useEffect(() => {
    if (!isInitializing && !token) {
      localStorage.clear();
      window.location.href = 'https://app.pro360erp.com/';
    }
  }, [token, isInitializing]);

  /* ---------- BACKFILL BRANCH ON DIRECT CASHIER/ADMIN LINKS ---------- */
  useEffect(() => {
    const needsBranch = (role === 'Cashier' || role === 'Admin' || role === 'Waiter') && !localStorage.getItem('BranchId');

    if (token && userid && needsBranch) {
      // don't block UI; get it in background
      ensureBranchIdForCashierFlow(userid);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, role, token, userid]);

  if (isInitializing || isEnsuringBranch) return <Loader />;

  return (
    <Routes>
      {/* Public */}
      <Route
        path="/login"
        element={
          <PlainLayout>
            <InventoryLogin />
          </PlainLayout>
        }
      />
      <Route
        path="/signup"
        element={
          <PlainLayout>
            <Signup />
          </PlainLayout>
        }
      />

      {/* Landing with role redirect */}
      <Route
        path="/"
        element={
          token ? (
            role === 'Admin' ? (
              <Navigate to="/home" replace />
            ) : role === 'Cashier' || role === 'Waiter' ? (
              <Navigate to="/cashier/home" replace />
            ) : role === 'Inventory Manager' ? (
              <Navigate to="/inventory/dashboard" replace />
            ) : role === 'Customer' ? (
              <Navigate to="/customer/menu" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          ) : (
            <PlainLayout>
              <LandingPage />
            </PlainLayout>
          )
        }
      />

      {/* Customer (Public) */}
      <Route
        path="/customer/menu"
        element={
          <PlainLayout>
            <CustomerMenu />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/menu/combo"
        element={
          <PlainLayout>
            <CustomerCombo />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/thirdparty"
        element={
          <PlainLayout>
            <ThirdParty />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/menu/cart"
        element={
          <PlainLayout>
            <AddtoCart />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/menu/cart/payment"
        element={
          <PlainLayout>
            <CardDetails />
          </PlainLayout>
        }
      />
      <Route
        path="/customer/wait"
        element={
          <PlainLayout>
            <WaitPage />
          </PlainLayout>
        }
      />

      {/* Kitchen (Public) */}
      <Route
        path="/kitchen"
        element={
          <PlainLayout>
            <KDSLogin />
          </PlainLayout>
        }
      />
      <Route
        path="/kitchen/orders"
        element={
          <PlainLayout>
            <KitchenDisplay />
          </PlainLayout>
        }
      />
      <Route
        path="/kitchen/history"
        element={
          <PlainLayout>
            <KitchenHistory />
          </PlainLayout>
        }
      />
      <Route
        path="/kitchen/order/:id/:name"
        element={
          <PlainLayout>
            <KitchenOrderDetail />
          </PlainLayout>
        }
      />

      {/* Cashier/Waiter (Protected) */}
      <Route
        path="/cashier/counterselection"
        element={
          <ProtectedRoute allowedRoles={['Cashier', 'Waiter']}>
            <PlainLayout>
              <CounterSelector />
            </PlainLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cashier/*"
        element={
          <ProtectedRoute allowedRoles={['Cashier', 'Waiter']}>
            <CashierLayout>
              <Routes>
                <Route path="home" element={<CashierMenu />} />
                <Route path="" element={<CashierMenu />} />
                <Route path="switchuser" element={<SwitchUserScreen />} />
                <Route path="payment" element={<PaymentComponent />} />
                <Route path="shiftopen" element={<OpeningCash />} />
                <Route path="opencashlist" element={<OpenCashList />} />
                <Route path="dayclose" element={<DayCloseForm />} />
                <Route path="dayopen" element={<DayOpeningForm />} />
                <Route path="dayopening" element={<DayOpeningList />} />
                <Route path="payin" element={<PayIn />} />
                <Route path="payout" element={<PayOut />} />
                <Route path="payinform" element={<PayInForm />} />
                <Route path="payoutform" element={<PayOutForm />} />
                <Route path="handovered" element={<HandOvered />} />
                <Route path="dispute" element={<Dispute />} />
                <Route path="handoverform" element={<HandOverForm />} />
                <Route path="waiterorders" element={<WaiterCall />} />
                <Route path="salehistory" element={<SaleHistory />} />
                <Route path="holdorders" element={<PayLater />} />
                <Route path="updateorder" element={<UpdateOrder />} />
                <Route path="orderdetails/:id" element={<CashOrderDetail />} />
                <Route path="cardpayment" element={<CardPayment />} />
                <Route path=":id" element={<Table />} />
                <Route path="tables/newreservation" element={<NewReservation />} />
                <Route path="deliveries" element={<Delivery />} />
                <Route path="delivery/list" element={<DeliveryList />} />
              </Routes>
            </CashierLayout>
          </ProtectedRoute>
        }
      />

      {/* Admin (Protected) */}
      <Route
        path="/home"
        element={
          <ProtectedRoute allowedRoles={['Admin']}>
            <MainLayout>
              <Dashboard />
            </MainLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/*"
        element={
          <ProtectedRoute allowedRoles={['Admin']}>
            <MainLayout>
              <Routes>
                <Route path="orders" element={<Orders />} />
                <Route path="ordersdnd" element={<OrderDragNDrop />} />
                <Route path="order/:id" element={<SingleOrder />} />

                <Route path="updateorder" element={<UpdateOrder />} />
                <Route path="orderdetails/:id" element={<CashOrderDetail />} />
                {/* Menu */}
                <Route path="menu" element={<Menu />} />
                <Route path="menu/:name/:id" element={<ItemDetails />} />
                <Route path="additems" element={<ItemNavBar />} />

                <Route path="customerlist" element={<Costumer />} />
                <Route path="customer/:id" element={<CostumerDetails />} />
                <Route path="addcustomer" element={<AddCostumer />} />

                <Route path="employee" element={<Employee />} />
                <Route path="employee/:id" element={<EmployeeDetails />} />
                <Route path="addemployee" element={<AddEmployee />} />

                <Route path="company" element={<Restaurant />} />
                <Route path="company/create" element={<CreateRestaurant />} />
                <Route path="company/branch/create" element={<CreateBranch />} />

                <Route path="delivery/create" element={<DeliveryPlatforms />} />

                <Route path="payment" element={<PaymentManagment />} />
                <Route path="posting" element={<PostingPOS />} />

                <Route path="master/list" element={<MasterPage />} />
                <Route path="master/itemmaster/create" element={<AddItemsMaster />} />
                <Route path="master/create" element={<AdminMaster />} />
                <Route path="master/bulkItems" element={<ItemBulkUpload />} />

                <Route path="master/update/:id" element={<UpdateMenuItem />} />
                <Route path="itemmaster/addcategory" element={<AddCategory />} />
                <Route path="itemmaster/subcategory" element={<AddSubCategory />} />
                <Route path="itemmaster/variants" element={<AddVarients />} />
                <Route path="itemmaster/uploadfile" element={<UploadFile />} />
                <Route path="itemmaster/addsons" element={<CreateAddOn />} />
                <Route path="itemmaster/modifier" element={<CreateModifier />} />
                <Route path="itemmaster/combos" element={<AddCombos />} />
                <Route path="itemmaster/countermaster" element={<CreateCounter />} />

                <Route path="master/usermaster/manageuser" element={<ManageUsers />} />
                <Route path="master/usermaster/manageuser/:userId" element={<EditUserRole />} />
                <Route path="master/usermaster/managerole" element={<ManageRoles />} />
                <Route path="master/usermaster/managerole/:roleId" element={<EditRoleRights />} />
                <Route path="master/usermaster/:id" element={<UserMaster />} />
                <Route path="usermanagement/usermaster/userrole" element={<UserRole />} />
                <Route path="usermanagement/usermaster/userclaim" element={<UserClaim />} />

                <Route path="master/currencymanagement" element={<AddCurrency />} />
                <Route path="master/currency/:id" element={<CurrencyDetail />} />
                <Route path="master/taxmanagement" element={<TaxManagment />} />
                <Route path="master/paymentmethod" element={<CreateMethod />} />
                <Route path="master/table" element={<TableMaster />} />
                <Route path="master/kitchen" element={<KitchenMaster />} />
                <Route path="master/discount" element={<CreateDiscount />} />
                <Route path="master/promotion" element={<PromotionMaster />} />
                <Route path="master/area" element={<AreaMaster />} />
                <Route path="master/brand" element={<BrandMaster />} />
                <Route path="master/merchant" element={<MarchaintMaster />} />
                <Route path="master/terminal" element={<TerminalMaster />} />

                <Route path="setting/notification" element={<Notification />} />
                <Route path="setting/profile" element={<PasswordReset />} />
                <Route path="setting/currency" element={<CurrencySetting />} />
                <Route path="setting/tax" element={<TaxSetting />} />
                <Route path="setting/theme" element={<ThemeSetting />} />

                <Route path="reports/list" element={<ReportsPage />} />
                <Route path="reports/dashboard" element={<ReportsDashboard />} />
                <Route path="reports/grid" element={<ReportGrid />} />
                <Route path="reports/order" element={<TotalOrder />} />
                <Route path="reports/totalsale" element={<SaleSummeryReport />} />
                <Route path="reports/3rdparty/chart" element={<ThirdPartReport />} />
                <Route path="reports/3rdparty" element={<ThirdPartyGrid />} />
                <Route path="reports/delivery" element={<DeliveryReport />} />
                <Route path="reports/tax" element={<TaxReport />} />
                <Route path="reports/cash" element={<CashReport />} />
                <Route path="reports/table" element={<TableReport />} />
                <Route path="reports/xreport" element={<XReceipt />} />
                <Route path="reports/zreport" element={<ZReport />} />
                <Route path="reports/category" element={<CategorySaleReport />} />
                <Route path="reports/cashier" element={<CashierSaleReport />} />
                <Route path="reports/payment" element={<PaymentSaleReport />} />
                <Route path="reports/customer" element={<CustomerReport />} />
                <Route path="reports/itemsale" element={<ItemSaleReport />} />
                <Route path="reports/saletax" element={<SaleTaxReport />} />
                <Route path="reports/shift" element={<ShiftOpen />} />
                <Route path="reports/day" element={<DayReports />} />
                <Route path="reports/sales-summary" element={<SalesSummaryReport />} />
                <Route path="reports/FlashSummary" element={<FlashSaleReport />} />

                <Route path="reports/sales-by-hour" element={<SalesByHourReport />} />
                <Route path="reports/sales-tax" element={<SalesTaxReport />} />
                <Route path="Reports/SalesByHour" element={<SalesByHourReport />} />
                <Route path="Reports/ProfitMargin" element={<ProfitMarginReport />} />
                <Route path="Reports/BestWorstSales" element={<BestWorstSalesReport />} />
                <Route path="Reports/DailySalesSummary" element={<DailySalesSummaryReport />} />
                <Route path="Reports/PurchaseTax" element={<PurchaseTaxReport />} />
              </Routes>
            </MainLayout>
          </ProtectedRoute>
        }
      />

      {/* Inventory Manager (Protected) */}
      <Route
        path="/inventory/*"
        element={
          <ProtectedRoute allowedRoles={['Inventory Manager']}>
            <MainInventoryLayout>
              <Routes>{/* put inventory routes here */}</Routes>
            </MainInventoryLayout>
          </ProtectedRoute>
        }
      />

      {/* 404 */}
      <Route
        path="*"
        element={
          <PlainLayout>
            <NotFoundPage />
          </PlainLayout>
        }
      />
    </Routes>
  );
};

export default AppRoutes;
